
import { contentfulClient } from './contentfulClient';

export async function testConnection(): Promise<boolean> {
  try {
    console.log('Testing connection to Contentful...');
    const contentTypes = await contentfulClient.getContentTypes();
    console.log('Successfully connected to Contentful!');
    console.log('Available content types:', contentTypes.items.map(type => ({ 
      id: type.sys.id, 
      name: type.name 
    })));
    return true;
  } catch (error) {
    console.error('Failed to connect to Contentful:', error);
    return false;
  }
}
